var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"wrapper\" ng-if=\"main.state.current.name !== 'login'\">\n<section ng-if=\"!main.inFrame()\" ng-include=\"'contenuto.header.html'\"></section>\n<section ng-if=\"!main.inFrame()\" ng-include=\"'contenuto.sidebar.html'\"></section>\n<section ng-include=\"'contenuto.maincontent.html'\"></section>\n</div>";
var id1="contenuto.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;